.button {
	&-container {
		display: flex;
		justify-content: flex-end;

		button {
			margin-right: 0 !important;
			margin-bottom: 0.5rem;
		}
	}
}

.findings {
	&-link {
		cursor: pointer;
	}
}

.table {
	&-container {
		margin-top: 0.5rem !important;
	}
}

.cell-line-break {
	word-break: break-word;
}
